import type {
  Hero as IHeroProps,
  StoreHero as IStoreHero,
  VapsHero as VapsHeroProps,
} from '@cinch-nx/data-storyblok'
import type { ComponentLayouts } from '@cinch-nx/storyblok-utils'
import {
  GenericHero,
  HeroWithRichText,
  type IHeroWithRichTextProps,
  LandingHero,
  LandingHeroV2,
  type LandingHeroV2Props,
  StoreHero,
  HeroSection,
  type HeroSectionProps,
  VapsHero,
} from './variants'
import { LandingHeroProps } from './variants/landing-hero/landing-hero'

export interface IHeroComponentProps {
  heroProps:
    | IHeroProps
    | IHeroWithRichTextProps
    | IStoreHero
    | LandingHeroProps
    | LandingHeroV2Props
    | undefined
  /**
   * Components for hero bloks the shared variants cannot import.
   * TODO: temporary, see LayoutProps.heroComponents.
   */
  heroComponents?: ComponentLayouts
}

export const Hero = ({ heroProps, heroComponents }: IHeroComponentProps) => {
  switch (heroProps?.component) {
    case 'GenericHero': {
      return <GenericHero {...(heroProps as IHeroProps)} />
    }
    case 'CarFinanceHero': {
      return <HeroWithRichText {...(heroProps as IHeroWithRichTextProps)} />
    }
    case 'StoreHero': {
      return <StoreHero {...(heroProps as IStoreHero)} />
    }
    case 'LandingHero': {
      return <LandingHero {...(heroProps as LandingHeroProps)} />
    }
    case 'LandingHero_V2': {
      return (
        <LandingHeroV2
          {...(heroProps as LandingHeroV2Props)}
          heroComponents={heroComponents}
        />
      )
    }
    case 'HeroSection': {
      return <HeroSection {...(heroProps as HeroSectionProps)} />
    }
    case 'VapsHero': {
      return <VapsHero {...(heroProps as VapsHeroProps)} />
    }
    default: {
      return null
    }
  }
}
